import { SvgIcon } from "@mui/material";

export default function DeleteWhite(props) {
  return (
    <SvgIcon
      fontSize="small"
      width="11"
      height="13"
      viewBox="0 0 11 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10.4023 2C10.5898 2 10.7773 2.1875 10.7773 2.375C10.7773 2.58594 10.5898 2.75 10.4023 2.75H9.95703L9.37109 11.1172C9.30078 11.9141 8.64453 12.5 7.87109 12.5H3.16016C2.38672 12.5 1.73047 11.9141 1.66016 11.1172L1.07422 2.75H0.652344C0.441406 2.75 0.277344 2.58594 0.277344 2.375C0.277344 2.1875 0.441406 2 0.652344 2H2.87891L3.48828 1.03906C3.67578 0.710938 4.05078 0.5 4.42578 0.5H6.60547C6.98047 0.5 7.35547 0.710938 7.54297 1.03906L8.15234 2H10.4023ZM4.42578 1.25C4.30859 1.25 4.19141 1.32031 4.12109 1.4375L3.74609 2H7.28516L6.91016 1.4375C6.83984 1.32031 6.72266 1.25 6.60547 1.25H4.42578ZM9.20703 2.75H1.82422L2.41016 11.0703C2.43359 11.4453 2.76172 11.75 3.16016 11.75H7.87109C8.26953 11.75 8.59766 11.4453 8.62109 11.0703L9.20703 2.75Z" />
    </SvgIcon>
  );
}
